import React, { useEffect, useState } from 'react'
import bnrmidlepic from '../../Assets/images/bnrmidlepic.png'
import hedricon from '../../Assets/images/hedricon.png'
import bnr from '../../Assets/images/inner-bnr.jpg'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { BASE_IMAGE_URL, BASE_URL } from '../../config'

const CommonBanner = ({ heading, page, subpage = '', pagelink = '', bannerImage="", middleText,classes="",slug=null }) => {
   const [bannerData, setBannerData] = useState({});
 
  const fetchBanner = async () => {
      try {
        const { data } = await axios.post(`${BASE_URL}/get-page-banner`,{slug:slug});
        if (data.responseCode === 1) {
          setBannerData(data.responseData);
        }
      } catch (err) {
        console.error(err);
      }
    };
    useEffect(()=>{
slug&&fetchBanner();
    },[slug])
  return (
    <section className="inner-banner-sec">
    
     {(bannerData.image||bannerImage) && <img className={classes} src={slug&&bannerData.image?`${BASE_IMAGE_URL}${bannerData.image}`:bannerImage} />}

      {/* {middleText && (
        <div className="commonbannerheading">
          <div className="container">
            <div className="row">
              <div className="row">
                <h1>{middleText}</h1>
              </div>
            </div>
          </div>
        </div>
      )}

      {heading&& <div className="inrbnr-content">
        <img src={bnrmidlepic} />
       <div className="iner-bnr-heding">
          <div>
            <span><img src={hedricon} /></span>
            <h2>{heading}</h2>
            <ul>
              <li><Link to={'/'}>Home</Link></li>
              {!subpage && <li>{page}</li>}
              {subpage && <>
                <li><Link to={pagelink}>{page}</Link></li>
                <li>{subpage}</li>
              </>}
            </ul>
          </div>
        </div>
      </div>} */}
      
    </section>

  )
}

export default CommonBanner